module.exports = __webpack_public_path__ + "img/apps-black.d92dbdb6.svg";